import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import Arbiter from 'common/modules/arbiter'
import Internal from 'common/modules/internal'

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    static getDerivedStateFromError() {
        return { hasError: true }
    }

    componentDidUpdate(prevProps) {
        const { sendAppError, sagasErrors } = this.props

        const hasNewErrors = sagasErrors.length !== prevProps.sagasErrors.length

        if (hasNewErrors) {
            sendAppError({
                error: sagasErrors[sagasErrors.length - 1],
            })
        }
    }

    componentDidCatch(error, errorInfo) {
        const { sendAppError } = this.props

        /* eslint-disable-next-line no-console */
        console.error(error)

        sendAppError({
            error,
            errorInfo,
        })
    }

    render() {
        const { hasError } = this.state
        const { children } = this.props

        if (hasError) {
            return <h1>Something went wrong.</h1>
        }

        return children
    }
}

const mapStateToProps = (state, props) => ({
    ...props,
    tag: state?.zoid?.tag,
})

const mapDispatchToProps = (dispatch) => ({
    sendAppError: (payload) => dispatch(Internal.creators.sendMessage({
        payload: {
            target: 'pico_arbiter',
            ...Arbiter.creators.sendAppError({
                payload,
            }),
        },
    })),
})

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    sendAppError: (payload) => {
        dispatchProps.sendAppError({
            ...payload,
            tag: stateProps.tag,
        })
    },
})

ErrorBoundary.defaultProps = {
    children: null,
    sagasErrors: [],
}

ErrorBoundary.propTypes = {
    sendAppError: PropTypes.func.isRequired,
    children: PropTypes.node,
    sagasErrors: PropTypes.arrayOf(PropTypes.instanceOf(Error)),
}

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
)(ErrorBoundary)
